import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey9,
  purple6,
  yellow2,
  yellow4,
} from 'approot/shared/styles/colours.style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { baseBoxShadowFocus } from 'approot/shared/styles/borders.style';
import {
  RichtextProps,
  richtextCommonCss,
} from 'approot/shared/richtext/richtext.style';
import { boxShadowInfoBoxStandard } from './info-box-speech.style';

export const InfoBoxNoteCorner = styled.div`
  svg {
    background: white;
    height: ${rem(24)};
    width: ${rem(24)};
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;

    path {
      fill: ${yellow4};
      stroke: ${yellow4};
    }
  }
`;

const baseNote = css`
  background-color: ${yellow2};
  border: 1px solid ${yellow4};
  border-radius: 0;
  position: relative;
  padding: ${rem(spacing24)} ${rem(spacing16)} ${rem(spacing16)}
    ${rem(spacing16)};
`;

export const InfoBoxNoteView = styled.div<RichtextProps>`
  ${richtextCommonCss}
  ${baseNote}
`;

export const InfoBoxNoteEdit = styled.div`
  position: relative;
  .ProseMirror {
    ${baseNote}

    &:hover,
    &:focus {
      box-shadow: none;

      &:before {
        content: '';
        position: absolute;
        right: ${rem(11)};
        top: -${rem(6)};
        width: ${rem(1)};
        height: ${rem(34)};
        background-color: ${purple6};
        transform: rotate(315deg);
        z-index: 2;
      }
    }
  }
`;

export const InfoBoxShadow = styled.div`
  box-shadow: ${boxShadowInfoBoxStandard};
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: ${rem(22)};
`;

type InfoBoxFocusProps = {
  $isFocused: boolean;
};

export const InfoBoxFocus = styled.div<InfoBoxFocusProps>`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    right: -2px;
    top: -2px;
    border-right: ${rem(28)} solid white;
    border-bottom: ${rem(28)} solid transparent;
  }

  ${({ $isFocused }) =>
    $isFocused &&
    `
  box-shadow: ${baseBoxShadowFocus};

  &:before {
    content: '';
    position: absolute;
    right: 11px;
    top: -7px;
    width: ${rem(2)};
    height: ${rem(39)};
    background-color: ${grey9};
    transform: rotate(315deg);
    z-index: 2;
    border-radius: ${rem(2)};
  }
  `}
`;

export const InfoBoxNote = styled.div`
  position: relative;
`;
